document.querySelectorAll('.nis2-assessment').forEach((block) => {
    const screenIntro     = block.querySelector('#nis2-intro');
    const screenQuestions = block.querySelector('#nis2-questions');
    const screenResults   = block.querySelector('#nis2-results');
    const questionEls     = block.querySelectorAll('.nis2-question');
    const progressFill    = block.querySelector('#nis2-progress-fill');
    const currentQLabel   = block.querySelector('#nis2-current-q');
    const totalQ          = questionEls.length;

    let scores       = [];
    let currentIndex = 0;

    const showScreen = (target) => {
        [screenIntro, screenQuestions, screenResults].forEach((s) => {
            const active = s === target;
            s.classList.toggle('is-active', active);
            s.setAttribute('aria-hidden', String(!active));
        });
        block.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    const showQuestion = (index) => {
        questionEls.forEach((q, i) => {
            const active = i === index;
            q.classList.toggle('is-active', active);
            q.setAttribute('aria-hidden', String(!active));
        });
        if (currentQLabel) currentQLabel.textContent = index + 1;
        if (progressFill)  progressFill.style.width = `${(index / totalQ) * 100}%`;
    };

    const hideAllForms = () => {
        block.querySelectorAll('.nis2-form-panel').forEach((p) => { p.classList.remove('is-visible'); });
    };

    const showForm = (formKey) => {
        const panel = block.querySelector(`[data-form-panel="${formKey}"]`);
        if (!panel) return;
        hideAllForms();
        // URL parameter appending commented out — embed panels no longer use iframes with base URLs.
        // const iframe = panel.querySelector('iframe');
        // if (iframe && iframe.dataset.baseUrl && !iframe.getAttribute('src')) {
        //     const url = new URL(iframe.dataset.baseUrl);
        //     url.searchParams.set('assessment_score', lastScore);
        //     url.searchParams.set('assessment_tier', lastTier);
        //     iframe.src = url.toString();
        // }
        panel.classList.add('is-visible');
    };

    const showResult = (totalScore) => {
        block.querySelectorAll('.nis2-result').forEach((r) => {
            const min   = parseInt(r.dataset.min, 10);
            const max   = parseInt(r.dataset.max, 10);
            const match = totalScore >= min && totalScore <= max;
            r.classList.toggle('is-active', match);
            r.setAttribute('aria-hidden', String(!match));
        });
        if (progressFill) progressFill.style.width = '100%';
        hideAllForms();
        showScreen(screenResults);
    };

    block.addEventListener('click', (e) => {
        // Start button
        if (e.target.closest('.nis2-start-btn')) {
            scores       = [];
            currentIndex = 0;
            showQuestion(0);
            showScreen(screenQuestions);
            return;
        }

        // Retake button
        if (e.target.closest('.nis2-retake-btn')) {
            scores       = [];
            currentIndex = 0;
            block.querySelectorAll('.nis2-answer.selected').forEach((a) => a.classList.remove('selected'));
            hideAllForms();
            showQuestion(0);
            showScreen(screenIntro);
            return;
        }

        // Close a form panel
        if (e.target.closest('.nis2-form-close')) {
            hideAllForms();
            return;
        }

        // Open a form panel
        const formBtn = e.target.closest('[data-form]');
        if (formBtn) {
            showForm(formBtn.dataset.form);
            return;
        }

        // Answer selection
        const answer = e.target.closest('.nis2-answer');
        if (answer) {
            answer.classList.add('selected');
            setTimeout(() => {
                scores.push(parseInt(answer.dataset.score, 10));
                if (currentIndex < totalQ - 1) {
                    currentIndex++;
                    showQuestion(currentIndex);
                    block.querySelectorAll('.nis2-answer.selected').forEach((a) => a.classList.remove('selected'));
                } else {
                    const total = scores.reduce((sum, s) => sum + s, 0);
                    showResult(total);
                }
            }, 300);
        }
    });
});
